import { HisSearchConstants } from '../model/search/his-search-constants';

export class HisQueryParamUtils {

    public static isFlatObjectFormat(queryParams: any): boolean {
        for (let key of Object.keys(queryParams)) {
            if (key.startsWith(HisSearchConstants.GROUPS + '0.' + HisSearchConstants.CRITERIA)) {
                console.log('his-search-parser-helper#isFlatObjectFormat()', 'true', '#queryParams', queryParams);
                return true;
            }
        }
        console.log('his-search-parser-helper#isFlatObjectFormat()', 'false', '#queryParams', queryParams);
        return false;
    }
}
